import { render, staticRenderFns } from "./AvenantDetail.vue?vue&type=template&id=d5f82d84&scoped=true"
import script from "./AvenantDetail.vue?vue&type=script&lang=ts"
export * from "./AvenantDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f82d84",
  null
  
)

export default component.exports